import {ansicolor} from "ansicolor";


/**
 * The `faeDebugger` class provides a debugger that can be used to organize
 * and display debug information in a structured format.
 *
 * I threw it together one afternoon, so it could probably use some cleanup.
 *
 */
class faeDebugger {
    name = "root";
    index = 0;
    fields = [];
    children = [];
    color_column;
    color_value;
    color_label;

    /**
     * Constructor for creating an instance of the class.
     * @param {string} name - The name of the instance.
     * @param {string} [column=ansicolor.bright.blue] - The color of the column.
     * @param {string} [value=ansicolor.black] - The color of the value.
     * @param {string} [label=ansicolor.dim.red.bgLightYellow.underline] - The color of the label.
     */
    constructor(
        name,
        column = ansicolor.bright.blue,
        value = ansicolor.black,
        label = ansicolor.dim.red.bgLightYellow.underline) {
        this.name = name;
        this.color_column = column;
        this.color_value = value;
        this.color_label = label;
    }

    /**
     * Adds a new line to the fields array.
     *
     * @param {string} key - The key for the new line.
     * @param {string} value - The value for the new line.
     *
     * @return {void}
     */
    addLine(key, value){
        let index = this.fieldMax();
        this.fields.push(new Field(index, key, value));
    }

    /**
     * Adds a block to the children array with the given key and value.
     *
     * @param {string} key - The key used to identify the block.
     * @param {any} value - The value of the block to be added.
     * @return {void}
     */
    addBlock(key, value) {
        let index = this.fieldMax();
        this.children.push(value);
    }

    /**
     * Calculates the maximum index value of an array of fields.
     *
     * @returns {Number} The maximum index or 0 if there are no fields.
     */
    fieldMax = () => {
        if(this.fields.length === 0) {
            return 0;
        }
        return Math.max(...(this.fields.map((f)=> f.index))) + 1;
    }

    /**
     * Converts an object to its simplified representation.
     *
     * @return {Array} An array of objects representing the converted object.
     */
    toObject() {
        let output = [];

        let maxChar = (this.fieldMax() + this.children.length).toString().length;
        for(let i = 0; i < this.fieldMax(); i++){
            let key = `_${i.toString().padStart(maxChar, '0')}_${this.fields[i].key}`;
            output.push({[key]: this.fields[i].value});
        }

        let index = this.fieldMax();
        if(this.children.length > 0) {
            let blockList =  this.children.map(
                (i,c) => {
                    return {
                        [`_${(c + index).toString().padStart(maxChar, '0')}_${i.name}`]:
                            i.toObject()};
                });
            output = output.concat(blockList);
        }

        return output;
    }

    /**
     * Logs the fields and children of the current group object in a grouped format.
     *
     * @returns {void}
     */
    toGroup() {

        const log = require('ololog').configure(
            {
                locate: false,

            });

        console.group(this.color_label(this.name));// c.dim.red.bgLightYellow.underline(this.name));
        let maxColumn = Math.max(...(this.fields.map(f => f.key.length)));

        //  Something I'd like to implement here would be to take the value field,
        //  and if it's an object or array provide some concatenation with pipe
        //  separator, with each column appropriately padded so they're the same width.
        for (const f of this.fields) {
            log(
                this.color_column(f.key.padStart(maxColumn,' ')),
                this.color_value(`| ${f.value}`)
            );
        }

        for(let i = 0; i < this.children.length; i++) {
            this.children[i].toGroup();
        }

        console.groupEnd();
    }
}

/**
 * Represents a field with an index, key, and value
 * @class
 */
class Field{
    index = 0;
    key = "unknown";
    value = "unknown";
    constructor(index, key, value) {
        this.index = index;
        this.key = key;
        this.value = value;
    }
}


export {faeDebugger};